import { render, staticRenderFns } from "./AMForgotUserIDAcc.vue?vue&type=template&id=1146a1f4&scoped=true"
import script from "./AMForgotUserIDAcc.vue?vue&type=script&lang=js"
export * from "./AMForgotUserIDAcc.vue?vue&type=script&lang=js"
import style0 from "./AMForgotUserIDAcc.vue?vue&type=style&index=0&id=1146a1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1146a1f4",
  null
  
)

export default component.exports